export class ErrorService {
    /* @ngInject */
    constructor($translate, $log) {
        this.$translate = $translate;
        this.$log = $log;
    }

    setErrorType(errorType) {
        this.$log.debug('Error type: ' + errorType);
        this.errorType = errorType;
    }

    getErrorMessageKey() {
        if (this.errorType) {
            return 'authentication.error-' + this.errorType;
        }
    }

    clearError() {
        this.errorType = null;
    }

}